export default __webpack_public_path__ + "static/app-features-3-709b8ee695f41b8015d369eca3498b7a.webp";